<template>
  <span
    class="rounded-circle bg-transparent text-white mx-2 d-flex justify-content-center alternative border pointer-on-hover align-items-center text-uppercase"
    :class="`border-${type}`"
  >
    {{ answered }}
  </span>
</template>
<script>
export default {
  props: {
    answered: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'info'
    }
  },
}
</script>
<style scoped>
  .alternative {
    width: 25px;
    height: 25px;
  }
</style>
